import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, Sun } from "@phosphor-icons/react";
import { COMPANY } from "../lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center">
                <Sun size={22} weight="fill" color="#FFFFFF" />
              </div>
              <div>
                <div className="text-white font-heading font-bold text-lg">
                  Hélios Solutions
                </div>
                <div className="text-xs text-slate-400">Énergie & Habitat</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md text-slate-400">
              Solutions énergétiques pour l'habitat : pompe à chaleur,
              rénovation énergétique, remplacement de chauffage. Étude
              personnalisée et sans engagement, accompagnement complet.
            </p>
            <p className="text-xs text-slate-500 mt-4 leading-relaxed">
              Aides disponibles selon votre situation. Reste à charge variable
              selon profil.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 font-heading">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li><Link data-testid="footer-nav-accueil" to="/" className="hover:text-white transition-colors">Accueil</Link></li>
              <li><Link data-testid="footer-nav-services" to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link data-testid="footer-nav-comment" to="/comment-ca-marche" className="hover:text-white transition-colors">Comment ça marche</Link></li>
              <li><Link data-testid="footer-nav-eligibilite" to="/eligibilite" className="hover:text-white transition-colors">Éligibilité</Link></li>
              <li><Link data-testid="footer-nav-contact" to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 font-heading">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone"
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone size={16} weight="fill" className="text-emerald-400" />
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <EnvelopeSimple size={16} className="text-emerald-400 mt-0.5" />
                <span className="break-all">{COMPANY.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-emerald-400 mt-0.5" />
                <span>{COMPANY.zone}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} Hélios Solutions – Énergie & Habitat. Tous droits réservés.
          </div>
          <div className="flex gap-4">
            <Link to="/mentions-legales" className="hover:text-slate-300" data-testid="footer-legal">Mentions légales</Link>
            <Link to="/mentions-legales" className="hover:text-slate-300" data-testid="footer-privacy">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
